import ApiService from './ApiService.js';
import moment from 'moment'
const uuidv1 = require('uuid/v1');
const queryString = require('querystring')

var ReportSubscriptionService = {
    
    findAll: function($data)
     {
        return new Promise(function(resolve,reject) {
            var $options= {};
            $options.url ="reportSubscription"
            $options.method="get"
            
            if($data) {
                var queryString = Object.keys($data).map(key => key + '=' + $data[key]).join('&');
                $options.url ="reportSubscription?"+queryString

            }
            ApiService.request($options)
                .then(response => {
                   // console.log('Gpt the data');
                   resolve(ReportSubscriptionService.formatData(response))
                    //resolve(response.data.data)
                }).catch(error=> {
                    reject(error);
                })
        });

    },
    submitReport: function($id)
    {
       return new Promise(function(resolve,reject) {
           var $options= {};
           $options.url ="reportSubscription/process/"+$id
           console.log($options.url)
           $options.method="get"
          
           ApiService.request($options)
               .then(response => {
                   console.log('Gpt the data');
                  resolve(response)
                   //resolve(response.data.data)
               }).catch(error=> {
                   console.log('got an error')
                   reject(error);
               })
       });

   },
   previewReport:function($filters) {
    return new Promise(function(resolve,reject) {
        var $options= {};
        $options.url ="previewReport/"+$filters.reportId+"?"+queryString.stringify($filters.filters)
        console.log($options.url)
        $options.method="get"
        ApiService.request($options)
            .then(response => {
                console.log('Gpt the data');
                console.log(response)
               resolve(response.data)
                //resolve(response.data.data)
            }).catch(error=> {
                console.log('got an error')

                reject(error);
            })
    });
   },
    findOne: function($data)
     {
        return new Promise(function(resolve,reject) {
            var $options= {};
            $options.url ="reportSubscription/"+$data.id
            console.log($options.url)
            $options.method="get"
            if(!$data) {
                $options.data = $data
            }
            ApiService.request($options)
                .then(response => {
                   // console.log('Gpt the data');
                    resolve(response.data.data)
                }).catch(error=> {
                    reject(error);
                })
        });

    },
    save: function ($data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.data=$data;
            console.log($data)
            $options.url = "reportSubscription/"+$data.id;
            $options.data =$data
            $options.method="post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
            });
    },
    bulkUpdate:function($data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.data=$data;
            console.log($data)
            $options.url = "bulkUpdateReportSubscription";
            $options.data =$data
            $options.method="post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
            });


    },
    create: function ($data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.data=$data;
            $options.url = "subscribe";
            $options.method="post"
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
            });
    },
    getStatus:function($data)  {
        console.log($data)
        var $i=0;
        var $query ={ "id":[]}
        return new Promise(function(resolve,reject) {
            //resolve({"1":{"status":0}});
            if($data.length==0) { 
                resolve({data:{data:{}}})
            } else {
            for($i=0;$i<$data.length;$i++)
            {
                $query.id.push($data[$i].id)
            }
            var $options= {};
            $options.url ="reportSubscriptionStatus/?requestId="+JSON.stringify($query)
            //console.log($options.url)
            $options.method="get"
            if(!$data) {
                $options.data = $data
            }
            ApiService.request($options)
                .then(response => {
                   // console.log('Gpt the data');
                   resolve(response)
                    //resolve(response.data.data)
                }).catch(error=> {
                    reject(error);
                })
            }
        });


    },
    validate: function($data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.data={};
            console.log($data)
            $options.url ='reportSubscription/validate'
            $options.data = $data;
            ApiService.request($options) 
                .then(response => {

                }).catch(error => {

                });
            });

    },
    formatData: function($data) 
    {
        var $i =0;
        var $subscriptions = $data.data.data;
        var $subscriptionList = []; 
        console.log('do you see any data')
        console.log($data)
        var $length = $subscriptions.length; 
        for($i=0;$i<$length;$i++) {
            if($subscriptions[$i].active==1) { 
            var $options = {};
            $options.id = $subscriptions[$i].id;
            $options.name = $subscriptions[$i].name
            $options.company = $subscriptions[$i].companyName;
            $options.reports = $subscriptions[$i].reports;
            $options.report_id =$subscriptions[$i].reports.id;
            $options.companies = $subscriptions[$i].companies;
            $options.processing  = $subscriptions[$i].processing;
            $options.report_log_id = $subscriptions[$i].report_log_id
            $options.columns = JSON.parse($subscriptions[$i].columns)
            $options.schedule_at = JSON.parse($subscriptions[$i].schedule_at)
            $options.filter_options = JSON.parse($subscriptions[$i].filter_options)
            $options.sort_options = JSON.parse($subscriptions[$i].sort_options)
            $options.layout_options = JSON.parse($subscriptions[$i].layout_options)
            $options.next_date = $subscriptions[$i].next_date; //moment($subscriptions[$i].next_date).format('MMM DD YYYY, H:mm:ss a')
            $options.owner = $subscriptions[$i].owner.username
            $options.company_id = $subscriptions[$i].companies.id
            $options.user = $subscriptions[$i].user.username
            $options.export_options= JSON.parse($subscriptions[$i].export_options)
            $options.email_to = JSON.parse($subscriptions[$i].email_to).mail_to
            $options.email_obj = JSON.parse($subscriptions[$i].email_to)
            $options.modified =$subscriptions[$i].modified
            $options.created_by =$subscriptions[$i].created_by
            $options.modified_by =$subscriptions[$i].modified_by
            $options.active = $subscriptions[$i].active
            $options.schedule_day = JSON.parse($subscriptions[$i].schedule_day)
            $options.set_day = $subscriptions[$i].set_day
            $subscriptionList.push($options)
            console.log('record finsihed');
            }

        }
        console.log('returned data')
        return $subscriptionList;
    }
};
export default ReportSubscriptionService;